import React from 'react';

interface P {
    className: string;
}

export function WebIcon({className}:P) {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 156.5 156.5" xmlSpace="preserve" className={className}>
            <path d="M114.3,156.5H42.2C18.9,156.5,0,137.6,0,114.3V42.2C0,18.9,18.9,0,42.2,0h72.2c23.2,0,42.2,18.9,42.2,42.2v72.2
                C156.5,137.6,137.6,156.5,114.3,156.5z M42.2,8.5C23.6,8.5,8.5,23.6,8.5,42.2v72.2c0,18.6,15.1,33.7,33.7,33.7h72.2
                c18.6,0,33.7-15.1,33.7-33.7V42.2c0-18.6-15.1-33.7-33.7-33.7H42.2z"/>
            <path d="M83.4,47.9l12.8-12.8c6.9-6.9,18.3-6.9,25.2,0l0,0c6.9,6.9,6.9,18.3,0,25.2L95.2,86.5
                c-6.9,6.9-18.3,6.9-25.2,0l0,0"/>
            <path d="M73.1,108.6l-12.8,12.8c-6.9,6.9-18.3,6.9-25.2,0l0,0c-6.9-6.9-6.9-18.3,0-25.2L61.3,70
                c6.9-6.9,18.3-6.9,25.2,0l0,0"/>
        </svg>
    );
}
